import React from "react";
import Flatpickr from "react-flatpickr";

const CustomDateInput = ({
  value,
  dateOptions,
  isRequired,
  keyName,
  label,
  errors,
  setDate,
  placeholder,
  isDisabled = false,
  isVersioned = false,
  versionedValue = null,
}) => {
  return (
    <>
      {/* Label */}
      <label className="block mb-1 font-medium">
        {label} {isRequired && <span className="text-red-500">*</span>}
      </label>

      {/* Versioned Date Picker (if available) */}
      {isVersioned && versionedValue && (
        <div className="mb-2">
          <Flatpickr
            disabled={true}
            options={dateOptions || { dateFormat: "Y-m-d" }}
            value={versionedValue}
            onChange={(selectedDates) => setDate(selectedDates)}
            className={`form-input w-full ${
              errors[keyName] ? "border-red-500" : ""
            }`}
            placeholder={placeholder || "Select Date"}
          />
        </div>
      )}

      {/* Editable Date Picker */}
      <Flatpickr
        disabled={isDisabled}
        options={dateOptions || { dateFormat: "Y-m-d" }}
        value={value || ""}
        onChange={(selectedDates) => setDate(selectedDates)}
        className={`form-input w-full ${
          errors[keyName] ? "border-red-500" : ""
        }`}
        placeholder={placeholder || "Select Date"}
      />

      {/* Error Message */}
      {errors[keyName] && (
        <p className="mt-1 text-sm text-red-500">{errors[keyName]}</p>
      )}
    </>
  );
};

export default CustomDateInput;
